import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { GetCategoriesByCourseId, GetCategoriesByCourseIdError, GetCategoriesByCourseIdSuccess, GetCourseById, GetCourseByIdError, GetCourseByIdSuccess, GetCourses, GetCoursesError, GetCoursesSuccess } from "./course.actions";
import { CourseService } from "src/app/_services/course.service";
import { catchError, map, switchMap } from "rxjs/operators";
import { Course } from "src/app/_models/Course";
import { of } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { CourseCategory } from "src/app/_models/CourseCategory";

@Injectable()
export class CourseEffects {
  constructor(private actions$: Actions,
    private courseService: CourseService){}

  public getCoursesEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetCourses),
      switchMap(() => 
        this.courseService.getCourses$().pipe(
          map((result: Course[]) => {
            return GetCoursesSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetCoursesError({error: error}));
          })
        )
      )
    )
  );

  public getCourseByIdEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetCourseById),
      switchMap((payload) => 
        this.courseService.getCourseById$(payload.courseId).pipe(
          map((result: Course) => {
            return GetCourseByIdSuccess({course: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetCourseByIdError({error: error}));
          })
        )
      )
    )
  );

  public getCategoriesByCourseIdEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetCategoriesByCourseId),
      switchMap((payload) => 
        this.courseService.getCategoriesByCourseId$(payload.courseId).pipe(
          map((result: CourseCategory[]) => {
            return GetCategoriesByCourseIdSuccess({categories: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetCategoriesByCourseIdError({error: error}));
          })
        )
      )
    )
  );  
}